import {ReactNode} from 'react';

type TimelineProps = {
    children: ReactNode;
}

export const Timeline = ({children}: TimelineProps) => {
    return <ol className="relative border-s border-outline">{children}</ol>;
}
